import { stripDiacritics } from "./strings";

const NOT_SLUG_CHARS = /[^a-z0-9]+/g;
const EDGE_HYPHENS = /^-+|-+$/g;

export function toSlug(value: unknown, maxLength?: number): string {
  const slug = stripDiacritics(String(value ?? ""))
    .toLowerCase()
    .replace(NOT_SLUG_CHARS, "-")
    .replace(EDGE_HYPHENS, "");
  if (maxLength === undefined) return slug;
  return slug.slice(0, maxLength).replace(EDGE_HYPHENS, "");
}
